/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/our-favorites.js":
/*!***********************************************!*\
  !*** ./zrc/scripts/sections/our-favorites.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper/js/swiper.esm */ "./node_modules/swiper/js/swiper.esm.js");

class OurFavorites extends window.HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.sliders = [];
    this.init();
    document.addEventListener('shopify:section:load', () => {
      this.init();
    });
  }
  init() {
    this.tabs();
    this.initSliders();
    this.configHeightsTexts();
  }
  tabs() {
    var myTabs = this.container.querySelectorAll('.favorite-tab');
    function myTabClicks(tabClickEvent) {
      for (var i = 0; i < myTabs.length; i++) {
        myTabs[i].classList.remove('is-active');
      }
      var clickedTab = tabClickEvent.currentTarget;
      clickedTab.classList.add('is-active');
      tabClickEvent.preventDefault();
      var myContentPanes = this.container.querySelectorAll('.favorite-tab-content');
      for (var _i = 0; _i < myContentPanes.length; _i++) {
        myContentPanes[_i].classList.remove('is-active');
      }
      var anchorReference = tabClickEvent.target;
      var activePaneId = anchorReference.getAttribute('href');
      var activePane = this.container.querySelector(activePaneId);
      activePane.classList.add('is-active');
      this.sliders.forEach(slider => slider.update());
    }
    for (var i = 0; i < myTabs.length; i++) {
      myTabs[i].addEventListener('click', myTabClicks.bind(this));
    }
  }
  initSliders() {
    var $sliders = this.container.querySelectorAll('.favorites-slider');
    $sliders.forEach($slider => {
      var slidesLength = parseInt($slider.dataset.slides, 10);
      var nextButton = $slider.querySelector('.swiper-button-next');
      var prevButton = $slider.querySelector('.swiper-button-prev');
      swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__.Swiper.use([swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__.Navigation]);
      var swiper = new swiper_js_swiper_esm__WEBPACK_IMPORTED_MODULE_0__.Swiper($slider, {
        centerInsufficientSlides: true,
        observer: true,
        observeParents: true,
        resistanceRatio: 0,
        slidesPerView: 'auto',
        longSwipesRatio: 0,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        watchOverflow: true,
        breakpoints: {
          0: {
            slidesOffsetBefore: slidesLength > 1 ? 20 : 0,
            slidesOffsetAfter: slidesLength > 1 ? 20 : 0,
            slidesPerGroup: 1,
            spaceBetween: 10
          },
          560: {
            slidesOffsetBefore: slidesLength > 2 ? 20 : 0,
            slidesOffsetAfter: slidesLength > 2 ? 20 : 0,
            slidesPerGroup: 2,
            spaceBetween: 10
          },
          750: {
            slidesOffsetBefore: slidesLength > 2 ? 26 : 0,
            slidesOffsetAfter: slidesLength > 2 ? 26 : 0,
            slidesPerGroup: 3,
            spaceBetween: 13
          },
          838: {
            slidesOffsetBefore: slidesLength > 3 ? 26 : 0,
            slidesOffsetAfter: slidesLength > 3 ? 26 : 0,
            slidesPerGroup: 3,
            spaceBetween: 13
          },
          1125: {
            slidesOffsetBefore: slidesLength > 4 ? 26 : 0,
            slidesOffsetAfter: slidesLength > 4 ? 26 : 0,
            slidesPerGroup: 4,
            spaceBetween: 13
          },
          1440: {
            slidesOffsetBefore: slidesLength > 4 ? 55 : 0,
            slidesOffsetAfter: slidesLength > 4 ? 55 : 0,
            slidesPerGroup: 5,
            spaceBetween: 16
          },
          1663: {
            slidesOffsetBefore: slidesLength > 5 ? 55 : 0,
            slidesOffsetAfter: slidesLength > 5 ? 55 : 0,
            slidesPerGroup: 5,
            spaceBetween: 16
          }
        }
      });
      this.sliders.push(swiper);
    });
  }
  configHeightsTexts() {
    var productCardTitles = this.container.querySelectorAll('.product-card-title');
    window.setHeightCardTexts(productCardTitles, '--product-card-title-height');
  }
}
if (window.customElements.get('our-favorites') == null) {
  window.customElements.define('our-favorites', OurFavorites);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"our-favorites": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/our-favorites.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgetmore_workflow"] = self["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;